<template>
  <div class="app">
    <div class="title">
      <div class="dis">
        <div class="title_text">用户管理</div>
      </div>
    </div>
    <div class="head_box">
      <div class="ipt_list">
        <div class="box1">
          <div class="dis">
            <div class="first_title">用户ID</div>
            <el-input v-model="value2" placeholder="请输入内容" clearable></el-input>
          </div>
        </div>
        <div class="box1">
          <div class="dis">
            <div class="other_title">用户昵称</div>
            <el-input v-model="value1" placeholder="请输入内容" clearable></el-input>
          </div>
        </div>
        <div class="box1">
          <div class="dis">
            <div class="other_title">手机号</div>
            <el-input v-model="value3" placeholder="请输入内容" clearable></el-input>
          </div>
        </div>
        <div class="box1">
          <el-button class="search_btn dis_center" type="primary" @click="rold()">
            <div class="dis_center">
              <div>搜索</div>
              <img src="../../assets/72.png" class="i72" alt="">
            </div>
          </el-button>
        </div>
      </div>
    </div>
    <div class="table_pad">
      <!-- <div class="dis">
        <el-button
          class="Add_btn dis_center"
          type="primary"
          @click="add_btn(0)"
        >
          <div class="dis_center">
            <img class="img11" src="../../assets/12.png" alt="" />
            <div>新增用户</div>
          </div>
        </el-button>
        <div class="btn_list dis">
          <div
            class="dis_center"
            @click="delete_btn(1)"
            v-if="userInfo.roleId == -1"
          >
            <img src="../../assets/144.png" class="img11" alt="" />删除
          </div>
          <div class="dis_center" @click="show_more2(0)">
            <img src="../../assets/15.png" class="img11" alt="" />冻结
          </div>
          <div class="dis_center no_border" @click="show_more2(1)">
            <img src="../../assets/16.png" class="img11" alt="" />解冻
          </div>
        </div>
      </div> -->
      <div class="table">
        <el-table v-loading="loading" element-loading-text="数据加载中" ref="multipleTable" :data="tableData"
          tooltip-effect="dark" style="width: 100%" stripe @selection-change="handleSelectionChange"
          :header-cell-style="{ 'text-align': 'center' }" :cell-style="{ textAlign: 'center' }">
          <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
          <el-table-column type="index" label="序号" width="55">
          </el-table-column>
          <el-table-column prop="id" label="用户ID" min-width="6%">
          </el-table-column>
          <el-table-column prop="headPhoto" label="用户头像" min-width="6%">
            <template slot-scope="scope">
              <div>
                <div v-if="scope.row.headPhoto">
                  <img v-if="
                    scope.row.headPhoto.indexOf('https://thirdwx.qlogo.cn') ==
                    -1
                  " :src="img_url + '/' + scope.row.headPhoto" class="img4" alt="" srcset="" />
                  <img v-else :src="scope.row.headPhoto" class="img4" alt="" srcset="" />
                </div>

                <img v-else src="../../assets/144.png" class="img4" alt="" srcset="" />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="nickName" label="用户昵称" min-width="10%">
          </el-table-column>
          <el-table-column prop="userPhone" label="手机号" min-width="10%">
          </el-table-column>
          <!-- <el-table-column prop="parentUserName" label="学生数量" min-width="10%">
          </el-table-column> -->
          <!-- <el-table-column prop="storeName" label="门店角色" min-width="6%">
            <template slot-scope="scope">
              <div class="" v-if="scope.row.storeAdminFlag == 0">普通用户</div>
              <div class="orange" v-if="scope.row.storeAdminFlag == 1">
                店长
              </div>
              <div class="other" v-if="scope.row.storeAdminFlag == 2">店员</div>
            </template>
          </el-table-column> -->

          <!-- <el-table-column prop="status" label="状态" min-width="6%">
            <template slot-scope="scope">
              <div class="yellow" v-if="scope.row.status == 0">冻结</div>
              <div class="blue" v-if="scope.row.status == 1">正常</div>
            </template>
          </el-table-column> -->

          <el-table-column prop="createTime" label="创建时间" min-width="12%">
          </el-table-column>
          <!-- <el-table-column prop="address" label="操作" min-width="10%">
            <template slot-scope="scope">
              <div class="dis table_btn">
                <div class="dis table_freeze">
                  <div v-if="scope.row.switch_type">解冻</div>
                  <div v-else class="blue">冻结</div>
                  <el-switch
                    v-model="scope.row.switch_type"
                    active-color="#FF8800"
                    inactive-color="#00B277"
                    @change="switch_change(scope.row, $event)"
                  >
                  </el-switch>
                </div>
                <div @click="jump_positionManagement(scope.row.id)">
                  店长管理
                </div>
                <div class="dis blue" @click="add_btn(1, scope.row)">
                  <img src="../../assets/17.png" class="img17" alt="" />
                  <div>修改</div>
                </div>
                <div class="dis table_delete" @click="delete_btn(0, scope.row.id)">
                  <img src="../../assets/18.png" class="img17" alt="" />
                  <div>删除</div>
                </div>
                <div class="dis table_freeze">
                  <div v-if="scope.row.switch_type">解禁</div>
                  <div v-else class="blue">禁言</div>
                  <el-switch
                    v-model="scope.row.switch_type"
                    active-color="#FF8800"
                    inactive-color="#00B277"
                    @change="switch_change(scope.row, $event)"
                  >
                  </el-switch>
                </div>
                <div @click="jump_userDetail(scope.row.id)">查看详情</div>
              </div>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
      <div class="page_box">
        <el-pagination background layout="prev, pager, next" @current-change="handleCurrentChange"
          :current-page.sync="pageNumber" :total="total">
        </el-pagination>
      </div>
    </div>

    <div class="shardow dis_center" v-if="show_shardow">
      <div class="show_box">
        <div class="show_title dis_center">
          <div v-if="show_type == 0">新增</div>
          <div v-else>修改</div>
          <img src="../../assets/19.png" class="img19" alt="" @click="close" />
        </div>
        <div class="show_detail show_detail_user">
          <!-- <div class="dis_center shardow_ipt_box">
            <div class="shardow_title">头像：</div>
            <div class="img_box2">
              <div class="img_box" @click="selectImg">
                <img v-if="
                  info.headPhoto.indexOf('https://thirdwx.qlogo.cn') == -1
                " :src="img_url + '/' + info.headPhoto" class="sons_img" alt="" srcset="" />
                <img v-else :src="info.headPhoto" class="sons_img" alt="" srcset="" />
              </div>
              <div class="img_text">
                建议尺寸：800像素 *800像素，图片大小不超过1M
              </div>
            </div>
          </div> -->
          <!-- <div class="dis_center shardow_ipt_box">
            <div class="shardow_title">用户名称：</div>
            <el-input class="shardow_ipt" v-model="info.nickName" placeholder="请输入内容"></el-input>
          </div> -->
          <div class="dis_center shardow_ipt_box">
            <div class="shardow_title">用户手机号：</div>
            <el-input class="shardow_ipt" v-model="info.userPhone" maxlength="11"
              oninput="value=value.replace(/[^\d]/g,'')" placeholder="请输入内容"></el-input>
          </div>
          <!-- <div class="dis_center shardow_ipt_box">
            <div class="shardow_title">分享人ID：</div>
            <el-input
              class="shardow_ipt"
              v-model="info.parentUserId"
              placeholder="请输入内容"
            ></el-input>
          </div> -->
          <!-- <div class="dis_center shardow_ipt_box">
            <div class="shardow_title">余额：</div>
            <el-input
              class="shardow_ipt"
              v-model="info.nickName"
              placeholder="请输入内容"
            ></el-input>
          </div> -->
          <!-- <div class="dis_center shardow_ipt_box">
            <div class="shardow_title">所属门店：</div>
            <el-select v-model="info.storeId" placeholder="请选择" @change="select_change" clearable filterable
              :disabled="info.storeAdminFlag == 1 || info.storeAdminFlag == 2">
              <el-option v-for="item in array3" :key="item.id" :label="item.storeName" :value="item.id">
              </el-option>
            </el-select>
          </div> -->
          <!-- <div class="dis_center shardow_ipt_box">
            <div class="shardow_title">门店角色：</div>
            <el-select
              v-model="info.storeAdminFlag"
              placeholder="请选择"
              v-if="info.storeAdminFlag == 0"
              disabled
            >
              <el-option
                v-for="item in options2"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="info.storeAdminFlag"
              placeholder="请选择"
              v-if="info.storeAdminFlag == 1"
            >
              <el-option
                v-for="item in options3"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="info.storeAdminFlag"
              placeholder="请选择"
              v-if="info.storeAdminFlag == 2"
            >
              <el-option
                v-for="item in options4"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div> -->
          <!-- <div class="dis_center shardow_ipt_box">
            <div class="shardow_title">招商角色：</div>
            <el-select
              v-model="info.parentDealerId"
              @change="select_array4"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in array4"
                :key="item.id"
                :label="item.dealerName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div> -->

          <!-- <div class="dis_center shardow_ipt_box">
            <div class="shardow_title">状态：</div>
            <el-select v-model="info.status" placeholder="请选择" clearable>
              <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div> -->
        </div>
        <div class="shardow_btn dis_center">
          <div class="shardow_btn1 dis_center" @click="close">取消</div>
          <button class="shardow_btn2 dis_center" @click="save" :disabled="disabled_save">
            确定
          </button>
        </div>
      </div>
    </div>

    <div class="shardow dis_center" v-if="show_shardow2">
      <div class="show_box">
        <div class="show_title dis_center">
          <div v-if="show_type == 0">充值</div>
          <div v-else>充值</div>
          <img src="../../assets/19.png" class="img19" alt="" @click="close" />
        </div>
        <div class="show_detail2">
          <div class="dis_center shardow_ipt_box">
            <div class="shardow_title">充值金额：</div>
            <el-input class="shardow_ipt" v-model="value6" placeholder="请输入内容"></el-input>
          </div>
        </div>
        <div class="shardow_btn dis_center">
          <div class="shardow_btn1 dis_center" @click="close">取消</div>
          <button class="shardow_btn2 dis_center" @click="save_pay" :disabled="disabled_save">
            确定
          </button>
        </div>
      </div>
    </div>

    <div class="shardow dis_center" v-if="show_delete">
      <div class="show_box show_box2" style="height: 300rem;">
        <div class="show_title dis_between">
          <div>删除确认</div>
          <img src="../../assets/19.png" class="img19" alt="" @click="close" />
        </div>
        <div class="dis_center shardow_deleteInfo">
          <img src="../../assets/20.png" class="img20" alt="" />
          <div>确定要删除所选择的用户吗？</div>
        </div>
        <div class="shardow_btn dis_center">
          <div class="shardow_btn1 dis_center" @click="close">取消</div>
          <div class="shardow_btn2 dis_center" @click="remove" v-if="delete_type == 0">
            确定
          </div>
          <div class="shardow_btn2 dis_center" @click="remove_list" v-if="delete_type == 1">
            确定
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  api,
  img_url,
  usergetMePage,usergetList,
  useredit,
  userremove,
  userfreezes,






} from "../js/api";
export default {
  data() {
    return {
      api: "",
      img_url: "",
      loading: false,
      disabled_save: false,
      userInfo: {},
      info: {
        nickName: "",
        userPhone: "",
        switch_type: false,
        status: 1,
      },
      multipleSelection: [],
      chooseId: "",
      show_type: 0,
      show_shardow: false,
      show_shardow2: false,
      show_delete: false,
      delete_type: 0,
      pageNumber: 1,
      pageSize: 10,
      total: 0,
      input: "",
      value1: "",
      value2: "",
      value3: "",
      value4: "",
      value5: "",
      value6: "",
      value7: "",
      value8: "",
      value9: "",
      value10: "",
      value11: "",
      value12: "",
      tableData: [],
      array3: [],
      array4: [],
      options1: [
        { label: "正常", value: 1 },
        { label: "冻结", value: 0 },
      ],
      options2: [
        { label: "普通用户", value: 0 },
        { label: "店员", value: 2 },
        { label: "店长", value: 1 },
      ],
      options3: [
        { label: "普通用户", value: 0 },
        { label: "店长", value: 1 },
      ],
      options4: [
        { label: "普通用户", value: 0 },
        { label: "店员", value: 2 },
      ],
      options5: [],
      multipleSelection: [],
      array5: [],
    };
  },
  created() {
    let that = this;
    // return
    that.api = api;
    that.img_url = img_url;
    that.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    that.ajaxload();
    // that.get_list();
    // that.get_list2();
  },
  methods: {
    selectImg(e) {
      this.choose_type = e;
      document.getElementById("filed_page").click();
    },


    get_detail(e) {
      let that = this;
      let json = {};
      json.id = e;
      usergetDetail(json).then((res) => {
        that.loading = false;
        //console.log(res);
        if (res.code == 200) {
          let data = res.data;
          that.info = data;
          that.show_type = 1;
          that.show_shardow = true;
          // that.obj = data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    jump_userDetail(e) {
      let that = this;
      that.$router.push("./userDetail?id=" + e);
    },
    getDays(startDateStr) {
      var startDate = new Date(startDateStr); // 将入职目期字符率转换为Date对象
      var endDate = new Date(); // 获歌当成日嬲-startDate)/(1000*60*60*24));// 计筹想差天巅
      var days = parseInt((endDate - startDate) / (1000 * 60 * 60 * 24));
      return days;
    },
    add_pay(e) {
      let that = this;
      that.chooseId = e;
      that.value6 = "";
      that.show_shardow2 = true;
    },
    save_pay() {
      let that = this;
      let json = {};
      if (!that.value6) {
        this.$message({
          message: "请输入充值金额",
          type: "warning",
          duration: 1000,
        });
        return;
      }
      json.amount = that.value6 * 100;
      json.userId = that.chooseId;
      recharge2({ params: json }).then((res) => {
        console.log(res);
        if (res.code == 200) {
          that.close();
          this.$message({
            message: "充值成功",
            type: "success",
          });
          that.ajaxload();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    select_change(e) {
      let that = this;
      let list = that.array3;
      for (let i in list) {
        if (list[i].id == e) {
          that.info.storeName = list[i].storeName;
          that.info.batchNo = list[i].batchNo;
          that.info.batchName = list[i].batchNoName;
          // that.info.batchNo = list[i].batchNo;
          // that.info.batchNoName = list[i].batchNoName;
        }
      }
    },
    select_array4(e) {
      let that = this;
      console.log(123456789, e);
      let list = that.array4;
      if (e) {
        for (let i in list) {
          if (list[i].id == e) {
            that.info.parentDealerName = list[i].dealerName;
          }
        }
      } else {
        that.info.parentDealerName = "";
      }
    },
    switch_change(e, w) {
      let that = this;
      console.log(e, w);
      that.info = JSON.parse(JSON.stringify(e));
      if (!w) {
        that.switch_save();
      } else {
        that.freeze_btn(e);
      }
      // that.switch_save();
    },
    rold() {
      let that = this;
      that.pageNumber = 1;
      that.ajaxload();
    },
    get_list() {
      let that = this;
      let json = {};

      StoregetList(json).then((res) => {
        console.log(res);
        if (res.code == 200) {
          let data = res.data;
          for (let i in data) {
            data[i].id = Number(data[i].id);
          }
          that.array3 = data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    get_list2() {
      let that = this;
      let json = {};

      DealergetList(json).then((res) => {
        console.log(res);
        if (res.code == 200) {
          let data = res.data;
          for (let i in data) {
            data[i].id = Number(data[i].id);
          }
          that.array4 = JSON.parse(JSON.stringify(data));
          let obj = {
            dealerName: "全部",
            id: -1,
          };
          data.unshift(obj);
          that.array5 = JSON.parse(JSON.stringify(data));
        } else {
          this.$message.error(res.message);
        }
      });
    },
    ajaxload() {
      let that = this;
      that.loading = true;
      let json = {};
      json.pageReq = {
        pageNumber: that.pageNumber,
        pageSize: that.pageSize,
      };
      json.entityParam = {
        // companyId: that.userInfo.companyId,
        // storeId: that.value4,
        // status: that.value5,
        // fromtType: 1,
      };
      if (that.value4) {
        json.entityParam.storeId = that.value4;
      }
      if (that.value5 !== "") {
        json.entityParam.status = that.value5;
      }
      if (that.value1 || that.value3 || that.value6) {
        json.keyWords = {};
      }
      if (that.value1) {
        json.keyWords.nickName = that.value1;
      }
      if (that.value2) {
        json.entityParam.id = that.value2;
      }
      if (that.value3) {
        json.keyWords.userPhone = that.value3;
      }
      if (that.value6) {
        json.keyWords.openId = that.value6;
      }
      if (that.value7) {
        json.entityParam.registDay = that.value7;
      }
      if (that.value8) {
        json.entityParam.registDay2 = that.value8;
      }
      if (that.value9) {
        json.entityParam.consumeMoney =
          JSON.parse(JSON.stringify(that.value9)) * 100;
      }
      if (that.value10) {
        json.entityParam.consumeMoney2 =
          JSON.parse(JSON.stringify(that.value10)) * 100;
      }
      if (that.value11) {
        if (that.value11 == -1) {
          json.entityParam.dealerFlag = true;
        } else {
          json.entityParam.parentDealerId = that.value11;
        }
      }
      if (that.value12.length > 0) {
        json.includeIds = that.value12;
      }
      // if (that.value4) {
      //   json.keyWords.storeId = that.value4;
      // }
      usergetList(json).then((res) => {
        that.loading = false;
        //console.log(res);
        if (res.code == 200) {
          let data = res.data.records;
          that.tableData = data;
          that.total = Number(res.data.total);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    switch_save() {
      let that = this;
      that.disabled_save = true;
      let json = that.info;
      // if (!json.userPhone) {
      //   this.$message({
      //     message: "请完善用户信息",
      //     type: "warning",
      //     duration: 1000,
      //   });
      //   that.disabled_save = false;
      //   return;
      // }
      // if (json.userPhone.length != 11) {
      //   this.$message({
      //     message: "请正确输入手机号",
      //     type: "warning",
      //     duration: 1000,
      //   });
      //   that.disabled_save = false;
      //   return;
      // }
      if (json.switch_type) {
        // json.status = 0;
      } else {
        json.status = 1;
      }
      console.log(json);
      useredit(json).then((res) => {
        that.disabled_save = false;
        // console.log(res);
        if (res.code == 200) {
          that.close();
          this.$message({
            message: "保存成功",
            type: "success",
          });
          that.ajaxload();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    freeze_btn(e) {
      let that = this;
      let json = {};
      json.userId = e.id;
      freeze({ params: json }).then((res) => {
        if (res.code == 200) {
          that.close();
          this.$message({
            message: "冻结成功",
            type: "success",
          });
          that.ajaxload();
        }
      });
    },
    save() {
      let that = this;
      that.disabled_save = true;
      let json = that.info;
      // if (!json.userPhone) {
      //   this.$message({
      //     message: "请完善用户信息",
      //     type: "warning",
      //     duration: 1000,
      //   });
      //   that.disabled_save = false;
      //   return;
      // }
      // if (json.userPhone.length != 11) {
      //   this.$message({
      //     message: "请正确输入手机号",
      //     type: "warning",
      //     duration: 1000,
      //   });
      //   that.disabled_save = false;
      //   return;
      // }
      console.log(json);
      // return;
      useredit(json).then((res) => {
        that.disabled_save = false;
        // console.log(res);
        if (res.code == 200) {
          that.close();
          this.$message({
            message: "保存成功",
            type: "success",
          });
          that.ajaxload();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    remove() {
      let that = this;
      let json = {};
      json.id = that.chooseId;
      userremove({ params: json }).then((res) => {
        // console.log(res);
        if (res.code == 200) {
          that.close();
          this.$message({
            message: "删除成功",
            type: "success",
          });
          that.ajaxload();
        } else {
          this.$message.error(res.message);
          that.close();
          that.ajaxload();
        }
      });
    },
    jump_positionManagement(e) {
      let that = this;
      that.$router.push("/positionManagement?id=" + e);
    },
    delete_btn(e, w) {
      let that = this;
      if (e == 0) {
        that.chooseId = w;
      } else if (e == 1) {
        if (that.multipleSelection.length == 0) {
          this.$message({
            message: "请选择用户",
            type: "warning",
          });
          return;
        }
      }
      that.delete_type = e;
      that.show_delete = true;
    },
    remove_list() {
      let that = this;

      let json = [];
      for (let i in that.multipleSelection) {
        json.push(that.multipleSelection[i].id);
      }
      userremoves(json).then((res) => {
        //console.log(res);
        if (res.code == 200) {
          that.close();
          this.$message({
            message: "删除成功",
            type: "success",
          });
          that.ajaxload();
        } else {
          this.$message.error(res.message);
          that.close();
          that.ajaxload();
        }
      });
    },
    show_more2(e) {
      let that = this;
      if (that.multipleSelection.length == 0) {
        this.$message({
          message: "请选择用户",
          type: "warning",
          duration: 1000,
        });
        return;
      }
      let json = [];
      for (let i in that.multipleSelection) {
        let obj = {
          id: that.multipleSelection[i].id,
          status: e,
        };
        json.push(obj);
      }

    },
    add_btn(e, w) {
      let that = this;
      if (e == 0) {
        that.info = {
          nickName: "",
          userPhone: "",
          switch_type: false,
          status: 1,
        };
      } else {
        that.info = JSON.parse(JSON.stringify(w));
        // that.get_detail(w.id);
      }
      that.show_type = e;
      that.show_shardow = true;
    },
    close() {
      let that = this;
      that.show_shardow = false;
      that.show_shardow2 = false;
      that.show_delete = false;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleCurrentChange(val) {
      let that = this;
      that.pageNumber = val;
      that.ajaxload();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("./userManagement.css");
</style>



// WEBPACK FOOTER //
// src/view/userManagement/userManagement.vue